import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import axios from "axios";
import serverURL from "../config";
import editImg from '../assets/pencil.png';
import deleteImg from '../assets/delete.png';
import { useNavigate } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import CategoryModal from "../components/CategoryModal";

const Category = () => {
    const [category, setCategory] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [categoryTitle, setCategoryTitle] = useState('');
    const [selectedCategory, setSelectedCategory] = useState(null);

    const navigate = useNavigate();

    const fetchCategory = async () => {
        const token = localStorage.getItem('token');
        try {
            const response = await axios.get(`${serverURL}/categories`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setCategory(response.data);
        } catch (error) {
            console.error('Failed to fetch category:', error);
        }
    }

    useEffect(() => {
        fetchCategory();
    }, []);

    const openCategoryModal = () => {
        setModalOpen(true);
    };

    const closeCategoryModal = () => {
        setModalOpen(false);
        setSelectedCategory(null);
    };

    const handleAdd = () => {
        openCategoryModal();
        setCategoryTitle('Add Category');
    }

    const handleEdit = (item) => {
        setSelectedCategory(item);
        openCategoryModal();
        setCategoryTitle('Edit Category')
    }

    const handleDelete = (item) => {
        setSelectedCategory(item);
        openCategoryModal();
        setCategoryTitle('Delete Category')
    }

    const handleViewDetails = (event) => {
        navigate(`/categories/${event.id}/${encodeURIComponent(event.category_name)}`, {
            state: {
                description: event.description,
                isActive: event.is_active,
            },
        });
    };

    return (
        <div className="flex flex-col min-h-screen">
            <Header headerTitle={"Question Category"} />
            <main className="flex-grow p-6">
                <div className="flex justify-end mb-4">
                    <button
                        onClick={handleAdd}
                        className="bg-gray-800 hover:bg-red-500 text-white p-2 rounded"
                    >
                        Add Category
                    </button>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {category.map((event) => (
                        <div
                            key={event.id}
                            className="bg-white p-4 rounded shadow-xl border hover:shadow-xl transition-shadow duration-300 relative"
                        >
                            <div className={`absolute top-2 right-2 text-white text-sm font-regular py-1 px-2 rounded ${event.is_active ? 'bg-green-500' : 'bg-red-500'}`}>
                                {event.is_active ? 'Active' : 'Inactive'}
                            </div>
                            <h3 className="text-lg font-semibold">{event.category_name}</h3>
                            <p className="text-gray-600 h-12">Description: {event.description}</p>
                            <div className='flex justify-between mt-2'>
                                <button
                                    onClick={() => handleViewDetails(event)}
                                    className="bg-gray-800 hover:bg-red-500 text-white p-2 rounded"
                                >
                                    View Details
                                </button>
                                <div className='flex justify-between gap-3'>
                                    <button data-tooltip-id="tooltip-edit" className='bg-gray-200 py-2 px-3 hover:bg-gray-300 rounded' onClick={() => handleEdit(event)}>
                                        <img src={editImg} width={'15px'} height={'15px'} alt='editIcon' />
                                    </button>
                                    <button data-tooltip-id="tooltip-delete" className='bg-gray-200 py-2 px-3 hover:bg-gray-300 rounded' onClick={() => handleDelete(event)}>
                                        <img src={deleteImg} width={'15px'} height={'15px'} alt='deleteIcon' />
                                    </button>
                                    <Tooltip
                                        id="tooltip-edit"
                                        content={"Edit"}
                                        place="top"
                                    />
                                    <Tooltip
                                        id="tooltip-delete"
                                        content={"Delete"}
                                        place="top"
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </main>
            <Footer />
            {/* Modal */}
            {modalOpen && (
                <CategoryModal title={categoryTitle} category={selectedCategory} closeCategoryModal={closeCategoryModal} fetchCategory={fetchCategory} />
            )}
        </div>
    );
};

export default Category;
